import { Action } from '@ngrx/store';

import * as actions from './ui.actions';
import { CAAction, ResponseSuccessAuthLogoutAction } from '../actions';

export interface State {
  enabledPriorities: Array<string>;
  customerFilter?: string;
  searchText?: string;
  loginMethod: LoginMethod;
}

export enum LoginMethod {
  email = 'EMAIL',
  mobile = 'MOBILE',
}

const INITIAL_STATE: State = {
  enabledPriorities: [],
  loginMethod: LoginMethod.email,
};

export function reducer(state: State = INITIAL_STATE, action: CAAction): State {
  switch (action.type) {
    case actions.REQUEST_TYPE_FILTER_CHANGE:
      return { ...state, enabledPriorities: (<any>action).payload };

    case actions.REQUEST_CUSTOMER_FILTER_CHANGE:
      return { ...state, customerFilter: (<any>action).payload };

    case actions.REQUEST_CUSTOMER_FILTER_RESET:
      return {
        ...state,
        customerFilter: undefined,
        enabledPriorities: state.enabledPriorities,
      };

    case actions.REQUEST_FEED_SEARCH:
      return { ...state, searchText: (<any>action).payload };

    case actions.REQUEST_FEED_SEARCH_RESET:
      return { ...state, searchText: undefined };

    case actions.SET_LOGIN_METHOD: {
      if (action.payload === LoginMethod.email || action.payload === LoginMethod.mobile) {
        return { ...state, loginMethod: action.payload };
      }
    }

    // clear filters after logout
    case ResponseSuccessAuthLogoutAction.type:
      return INITIAL_STATE;
    default:
      return state;
  }
}
